// Constants
import { DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE } from "../../../constants";

const DEFAULT_PAGINATION_DETAILS = {
  pageSize: DEFAULT_PAGE_SIZE,
  pageNumber: DEFAULT_PAGE_NUMBER,
};

export { DEFAULT_PAGINATION_DETAILS };
